export default "__VITE_ASSET__QLdBEbdD__"